import { rgba } from 'polished';
export const color = {
    light: {
        // theme: even table row color
        tableRowColor0: '#e5e5e5',
        // theme: odd table row color
        tableRowColor1: '#DCDCDC',
        // text color in primary bg
        primaryTextColor: '#DCDCDC',
        // theme: main text color
        textColor0: '#232526',
        // const: text color
        textColor1: '#232526',
        // light text color
        textColor2: '#797979',
        // theme: main button text color
        buttonTextColor: '#232526',
        // theme: main button bg color
        buttonColor: '#FFF',
        // theme: main button bg color in group mode
        buttonGroupColor: '#f4f4f4',
        // theme: main border color
        borderColor: '#c3c3c3',
        // theme: light border color
        focusBorderColor: '#87aef3',
        // theme: main bg color
        bgColor: '#eaeaea',
        // theme: light bg color
        bgColor1: '#e5e5e5',
        // theme: active bg color
        activeBgColor: '#c3c3c3',
        // theme: blur bg color
        blurBgColor: rgba('#eaeaea', 0.85),
        // primary-color
        primary: '#017aff',
    },
    dark: {
        tableRowColor0: '#262626',
        tableRowColor1: '#292929',
        primaryTextColor: '#DCDCDC',
        textColor0: '#DCDCDC',
        textColor1: '#232526',
        textColor2: '#797979',
        buttonTextColor: '#DCDCDC',
        buttonColor: '#5B5B5B',
        buttonGroupColor: '#292929',
        borderColor: '#303237',
        focusBorderColor: '#87aef3',
        bgColor: '#111013',
        bgColor1: '#202125',
        activeBgColor: '#262626',
        blurBgColor: rgba('#1D1D1D', 0.85),
        primary: '#017aff',
    },
};
export const status = {
    danger: '#F96057',
    warning: '#F8CE52',
    success: '#5FCF65',
    default: '#E6E6E6',
    info: '#87aef3',
};
